import React from 'react';
import PropTypes from 'prop-types';

const TextField = (props) => {
    const onChange = (event) => {
        props.onChange(event.target.value);
    };

    return (
        <div className="ui-text-field">
            <input
                className="ui-text-field__input"
                maxLength={props.maxLength}
                onChange={onChange}
                type="text"
                value={props.value}
            />
        </div>
    );
};

TextField.defaultProps = {
    maxLength: null,
};

TextField.propTypes = {
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default TextField;
